/*
 * Copyright (c) 2021. World Wide Generation Ltd
 */

import React, { useState } from 'react';
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap';
import { BasicAlert } from '../../../components/alert/BasicAlert';
import Footer from '../../../components/footer';
import { TestimonialsContainer } from '../../../components/testimonials/TestimonialsContainer';
import RequestDemoModal from '../../../components/request-demo-modal';
import { getAppFlavourCards } from '../partials/cards';
import { HomepageCardGrid } from '../partials/HomepageCard';
import { NetworkSection } from './NetworkSection';
import { useSelector } from 'react-redux';
import { RootState, useAppSelector } from '../../../reducers';
import { AppFlavour } from '../../../config/app-config';
import { RegionSwitcher } from './RegionSwitcher';
import './styles.scss';
import { CarbonCalculatorsCallToAction } from '../partials/CarbonCalculatorsCallToAction';
import { isStaff } from '../../../selectors/user';
import { PartnerSectionSimple } from './PartnerSectionSimple';
import { BundlePricingCallToAction } from '../partials/BundlePricingCallToAction';

interface ModalState {
  title?: JSX.Element,
  isPartner?: boolean
  isOpen: boolean;
}

export function DefaultHome() {

  const [showComingSoon, setComingSoon] = useState(false);
  const [requestModalOpen, setRequestDemoModalOpen] = useState<ModalState>({
    isOpen: false,
    title: <></>,
    isPartner: false,
  });
  const [submitMessage, setSubmitMessage] = useState('');
  const isLoggedIn = useSelector((state: RootState) => state.currentUser.loaded);
  const isUserStaff = useAppSelector(isStaff);

  const toggleComingSoon = () => setComingSoon(!showComingSoon);
  const toggleRequestDemoModal = (props?: Partial<ModalState>) => {
    setRequestDemoModalOpen({
      title: props?.title ?? <></>,
      isPartner: Boolean(props?.isPartner),
      isOpen: !requestModalOpen.isOpen,
    });
  };

  const cards = getAppFlavourCards(AppFlavour.DEFAULT, isLoggedIn, isUserStaff);
  const customTitle = requestModalOpen.title?.props.children;
  const title = customTitle ? `Get in touch with ${customTitle}` : undefined;

  return (
    <div className='homepage-container d-flex flex-column p-4' >
      <BasicAlert className={'text-center success-alert-container'} type={'success'}>{submitMessage}</BasicAlert>
      <div className='homepage-content flex-fill'>
        <div className='hp-header'>
          <div className='d-flex'>
            <div className='flex-fill'>
              <h1>Marketplace</h1>
            </div>
            <div className='text-right'>
              <RegionSwitcher />
            </div>
          </div>
          <div className='mt-3'>
            <p className='text-xl text-ThemeTextLight'>Welcome to the G17Eco Marketplace. We have curated the apps and services from partners
              around the world to help you excel in mapping, monitoring, measuring, managing and marketing
              of your sustainability performance - end to end, on one interoperable platform.</p>
          </div>
        </div>

        <BundlePricingCallToAction />

        <div className='homepage-inner-container'>

          <div className='mt-5 d-flex flex-column'>
            <h3>Solutions</h3>
            <HomepageCardGrid cards={cards.filter(card => card.solutions)} toggleRequestDemoModal={toggleRequestDemoModal} />

            <h3>Coming soon</h3>
            <HomepageCardGrid cards={cards.filter(card => card.comingSoon)} toggleRequestDemoModal={toggleRequestDemoModal} />

          </div>
        </div>

        <CarbonCalculatorsCallToAction size='lg' />

        {/* <div className='mt-4 text-center'>
            <Button color='primary' className='join-btn' onClick={() => toggleRequestDemoModal()}>Find out more or book a demo?</Button>
          </div> */}

        <div className='mt-6 homepage-inner-container'>

          <PartnerSectionSimple mode='emea' />

          {/* <div className='text-center'>
            <Button color='primary' className='join-btn' onClick={() => toggleRequestDemoModal()}>Join G17Eco as a partner</Button>
          </div> */}

          <h3 className='mt-6'>G17Eco member testimonials</h3>
          <div className='mt-4'>
            <TestimonialsContainer tags={['london']} />
          </div>

          <div className='mt-6'>
            <NetworkSection />
          </div>

        </div>
      </div>

      <Modal isOpen={showComingSoon} toggle={toggleComingSoon} backdrop='static'>
        <ModalHeader toggle={toggleComingSoon}>Coming Soon</ModalHeader>
        <ModalBody>
          This feature is not ready yet. Please check back later.
          <div className='mt-3 text-right'>
            <Button onClick={() => setComingSoon(false)}>OK</Button>
          </div>
        </ModalBody>
      </Modal>
      <RequestDemoModal
        isOpen={requestModalOpen.isOpen}
        toggle={toggleRequestDemoModal}
        onSubmit={() => {
          setSubmitMessage('Message sent. We’ll be in touch shortly.');
          setTimeout(() => setSubmitMessage(''), 10000);
        }}
        interestedIn={requestModalOpen.isPartner ? 'Partners' : ''}
        title={title}
      />
      <Footer />
    </div>
  )
}
